module.exports = __webpack_public_path__ + "static/media/brand.3cfccf7f.svg";